import {
  FormHelperText,
  CheckboxProps,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import { useField } from 'formik';

export const MFCheckbox = function ({
  label,
  name,
  onChange,
  checked,
  sx,
  ...props
}: CheckboxProps & { label: React.ReactNode; name: string }): JSX.Element {
  const [field, meta] = useField(name);
  checked = checked || field.value;
  onChange = onChange || field.onChange;
  const errorText = meta.error && meta.touched ? meta.error : '';

  const errorId = `${name}-error`;
  const checkBoxLabel = typeof label === 'string' ? label : '';
  const containsAsterisk = checkBoxLabel.includes('*');
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            {...field}
            {...props}
            checked={checked}
            onChange={onChange}
            aria-invalid={!!errorText}
            inputProps={{
              ...props.inputProps,
              ...(containsAsterisk && {
                'aria-label': `${checkBoxLabel?.replace('*', '').trim()} required`,
                'aria-required': true,
              }),
            }}
          />
        }
        name={name}
        label={label}
        sx={{
          '& .Mui-disabled': {
            cursor: !props.disabled ? 'pointer' : 'not-allowed !important',
            pointerEvents: 'all',
          },
          ...sx,
        }}
      />

      {errorText && (
        <FormHelperText
          error
          id={errorId}
          role="alert"
          aria-live="assertive"
          sx={{ marginLeft: 'unset' }}>
          {errorText}
        </FormHelperText>
      )}
    </FormGroup>
  );
};

export default MFCheckbox;
